import * as React from "react";
import type { SVGProps } from "react";
const SvgDepositIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="deposit_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M656 70.144a85.333 85.333 0 0 1 99.243 63.317l43.52 176.598a42.539 42.539 0 0 1-4.352 31.274h16.256A85.333 85.333 0 0 1 896 426.667v143.445h16.47a42.667 42.667 0 1 1 0 85.333H896v197.888a85.333 85.333 0 0 1-85.333 85.334H213.333A85.333 85.333 0 0 1 128 853.333V578.39a42.453 42.453 0 0 1-11.05-20.522L55.082 276.565a85.333 85.333 0 0 1 66.986-102.101L656 70.144zm154.667 499.968V426.667H213.333v426.666h597.334V655.445H616.576l42.581 41.643a42.667 42.667 0 0 1-59.69 61.013l-150.614-147.37 152.662-131.115a42.667 42.667 0 0 1 55.552 64.81l-29.995 25.729h183.595zm-94.72-239.659L672.427 153.9 138.41 258.219l22.272 101.29c14.506-11.392 32.81-18.176 52.65-18.176h506.88a42.837 42.837 0 0 1-4.309-10.88z"
    />
  </svg>
);
export default SvgDepositIcon;
